import { render, staticRenderFns } from "./DetailsNews.vue?vue&type=template&id=6ca6c50e&scoped=true&"
import script from "./DetailsNews.vue?vue&type=script&lang=ts&"
export * from "./DetailsNews.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsNews.vue?vue&type=style&index=0&id=6ca6c50e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca6c50e",
  null
  
)

export default component.exports